class PhysicalInnValidator {
	regexp = /^([0-9]{12})$/;
	message = '';

	validate = (value: string): boolean => {
		let result = this.regexp.test(value);
		this.message = 'Поле должно содержать 12 цифр';

		if (!result) {
			return result;
		}

		const inn = value;

		let n11 =
			7 * parseInt(inn[0]) +
			2 * parseInt(inn[1]) +
			4 * parseInt(inn[2]) +
			10 * parseInt(inn[3]) +
			3 * parseInt(inn[4]) +
			5 * parseInt(inn[5]) +
			9 * parseInt(inn[6]) +
			4 * parseInt(inn[7]) +
			6 * parseInt(inn[8]) +
			8 * parseInt(inn[9]);
		n11 = (n11 % 11) % 10;

		result = n11 === parseInt(inn[10]);

		if (result) {
			let n12 =
				3 * parseInt(inn[0]) +
				7 * parseInt(inn[1]) +
				2 * parseInt(inn[2]) +
				4 * parseInt(inn[3]) +
				10 * parseInt(inn[4]) +
				3 * parseInt(inn[5]) +
				5 * parseInt(inn[6]) +
				9 * parseInt(inn[7]) +
				4 * parseInt(inn[8]) +
				6 * parseInt(inn[9]) +
				8 * n11;

			n12 = (n12 % 11) % 10;
			result = n12 === parseInt(inn[11]);
		}
		this.message = 'Некорректный ИНН физического лица';
		return result;
	};
}

export default PhysicalInnValidator;
